import React from 'react';
import './Breadcrumb.css';

const Breadcrumb = () => {
  return (
    <div className="breadcrumb-container">
      <div className="breadcrumb-overlay">
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">About UPPVL</h1>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
